<template>
  <Modal
    class="quickModal"
    v-model="modalStatus" 
    width="1200" 
    :transfer="false"
  >
    <div>
      <Select v-model="gameid" style="width: auto; min-width: 120px;" @on-change="getData()">
        <Option :value="210">{{ '新澳门六合彩' }}</Option>
        <Option :value="1">{{ '香港六合彩' }}</Option>
      </Select>
    </div>
    <lida-table
      :propscolumns="theadData"
      :data="logData"
      :isSearch="false"
      :sortStatus="false"
      :propsPageSize="30"
      :SpinLoading="SpinLoading"
    >
    </lida-table>
    <div slot="footer">
      <Button type="primary" @click="modalStatus=false">{{ $t("common.close") }}</Button>
    </div>
  </Modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    tableModal: {
      type:Boolean,
      default: false
    },
  },
  data () {
    return {
      gameid: 210,
      logData: [],
      SpinLoading: false
    }
  },
  computed: {
    ...mapGetters(["getgameid"]),
    modalStatus: {
      get() {
        return this.tableModal
      },
      set(val) {
        this.$emit('update:tableModal', val)
      }
    },
    theadData () {
      return {
        logtime: {
          title: this.$t('common.date&time'),
          key: 'logtime',
          align: 'center',
          render: (h, params) => h('span', params.row.logtime)
        },
        gameclass: {
          title: this.$t('front.gameNamge'),
          key: 'gameclass',
          align: 'center',
          render: (h, params) => h('span', this.gameid == 210 ? '新澳门六合彩' : '香港六合彩')
        },
        oddname: {
          title: this.$t('common.gameKind'),
          key: 'oddname',
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.oddname)
          }
        },
        troddidname: {
          title: this.$t('common.betOption'),
          key: 'troddidname',
          align: 'center',
          width: 300,
        },
        trodddiff: {
          title: this.$t("traderecord.changeValue"),
          key: 'trodddiff',
          align: 'center'
        },
      }
    },
  },
  watch: {
    modalStatus (bool) {
      if (bool) {
        this.SpinLoading = true
        this.getData()
      }
    },
    getgameid (getgameid) {
      this.gameid = [1, 210].includes(getgameid) ? getgameid : 210
    }
  },
  methods: {
    async getData () {
      try {
        const res = await this.$axios.liveshow.chlog(this.gameid)
        this.logData = res
      } catch (error) {
        
      } finally {
        setTimeout(() => {
          this.SpinLoading = false
        }, 500);
      }
    }
  }
}
</script>